module.exports = __webpack_public_path__ + "static/media/tutorial-step-3.0bd7965d.png";